import React, { MouseEvent } from 'react';
import { IconButton } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';

type RowActionButtonProps = {
  onOpen(anchor: HTMLButtonElement): void;
};

// Botão "..." que abre o menu de ações da linha sem disparar o clique da própria linha.
const RowActionButton: React.FC<RowActionButtonProps> = ({ onOpen }) => {
  function handleClick(e: MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    onOpen(e.currentTarget);
  }

  return (
    <IconButton size="small" color="default" onClick={handleClick}>
      <MoreHoriz fontSize="small" />
    </IconButton>
  );
};

export default RowActionButton;
